import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { CustomLoader } from '../custom-loader';
import './styles.less';

const SimpleTableComponent = ({ rows, columns, lastRowStatus, withOutMinHeight, isTableDataLoading }) => {
	if (isTableDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className={`simple-table${withOutMinHeight ? ' simple-table__no-min-height' : ''}`}>
			<Table basic="very" className="simple-table__table">
				<Table.Body>
					{!rows.length && (
						<Table.Row>
							<Table.Cell className="simple-table__no-data">Данные не найдены</Table.Cell>
						</Table.Row>
					)}
					{rows?.map((row, index) => {
						if (row.group) {
							return (
								<Table.Row key={row.group} className="simple-table__table-group-title">
									<Table.Cell colSpan="3">{row.group}</Table.Cell>
								</Table.Row>
							);
						}

						return (
							<Table.Row
								key={row.id}
								className={`simple-table__table-row${
									lastRowStatus && index === rows.length - 1
										? ` simple-table__table-row_${lastRowStatus}`
										: ''
								}`}
							>
								{columns.map(
									({
										id,
										width,
										customComponent: CustomComponent,
										subCustomComponent: CustomSubComponent,
										...columnData
									}) => {
										if (CustomComponent && CustomSubComponent) {
											return (
												<React.Fragment key={id}>
													<Table.Cell
														key={`${id}-main`}
														className="simple-table__table-cell"
														style={{ width }}
													>
														<CustomComponent
															rowData={row}
															columnId={id}
															columnData={columnData}
														/>
													</Table.Cell>
													<Table.Cell
														key={`${id}-sub`}
														className="simple-table__table-cell"
														style={{ width }}
													>
														<CustomSubComponent
															rowData={row}
															columnId={id}
															columnData={columnData}
														/>
													</Table.Cell>
												</React.Fragment>
											);
										}

										if (CustomComponent) {
											return (
												<Table.Cell
													colSpan={2}
													key={id}
													className="simple-table__table-cell"
													style={{ width }}
												>
													<CustomComponent
														rowData={row}
														columnId={id}
														columnData={columnData}
													/>
												</Table.Cell>
											);
										}

										return (
											<Table.Cell className="simple-table__table-cell" key={id} style={{ width }}>
												{row[id]}
											</Table.Cell>
										);
									},
								)}
							</Table.Row>
						);
					})}
				</Table.Body>
			</Table>
		</div>
	);
};

SimpleTableComponent.propTypes = {
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			width: PropTypes.string,
			customComponent: PropTypes.elementType,
			subCustomComponent: PropTypes.elementType,
		}),
	),
	rows: PropTypes.arrayOf(
		PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number])),
	),
	lastRowStatus: PropTypes.oneOf(['success', 'danger', '']),
	withOutMinHeight: PropTypes.bool,
	isTableDataLoading: PropTypes.bool,
};

export { SimpleTableComponent };
